<template>
  <Layout> <RouterView /> </Layout>
</template>

<script>
import Layout from "./horizontal";

export default {
  components: {
    Layout,
  },
  mounted() {},
};
</script>
